import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_BILLING', '')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export enum AffectedBalance {
  PATIENT = 'Patient',
  INSURANCE = 'Insurance',
}

export interface ProcedureAdjustmentInput {
  procedureLogId: string
  amount: number
  adjustmentTypeId: string
  affectedBalance: AffectedBalance
}

export interface CreateAdjustmentRequest {
  appointmentId: string
  procedureAdjustments: ProcedureAdjustmentInput[]
}

export interface Adjustment {
  adjustment_id: string
  appointment_id: string
  patient_id: string
  clinic_id: string
  date_time_created_at?: string
  date_time_updated_at?: string
}

export interface ProcedureAdjustment {
  procedure_adjustment_id: string
  adjustment_id: string
  procedure_log_id: string
  amount: number
  adjustment_type_id: string
  affected_balance: AffectedBalance
  date_time_created_at?: string
  date_time_updated_at?: string
}

export type CreateAdjustmentResponse = ApiResponse<{
  adjustment: Adjustment
  procedure_adjustments: ProcedureAdjustment[]
}>

export const createAdjustment = async (
  payload: CreateAdjustmentRequest,
): Promise<CreateAdjustmentResponse> => {
  try {
    const response = await axios.post<CreateAdjustmentResponse>(
      `${BUSINESS_LAYER_API}/api/v1/adjustment`,
      payload,
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createAdjustment:', e)
    throw e
  }
}
